import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionJuradaViolenciaGeneroByID = () => {
  const [loadingUpdateDeclaracionJuradaViolenciaGeneroById, setLoadingCreateDeclaracionJuradaViolenciaGenero] = useState(false);
  const [successUpdateDeclaracionJuradaViolenciaGeneroById, setSuccessCreateDeclaracionJuradaViolenciaGenero] = useState(false);
  const [errorUpdateDeclaracionJuradaViolenciaGeneroById, setErrorCreateDeclaracionJuradaViolenciaGenero] = useState(null);
  const [dataUpdateDeclaracionJuradaViolenciaGeneroById, setDataDeclaracionJuradaViolenciaGenero] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionJuradaViolenciaGeneroById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionJuradaViolenciaGenero(true);
    setSuccessCreateDeclaracionJuradaViolenciaGenero(false);
    setErrorCreateDeclaracionJuradaViolenciaGenero(null);

    apiRecord.updateSolicitudDeclaracionJuradaFuerzaMayorByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionJuradaViolenciaGenero(false);
      setSuccessCreateDeclaracionJuradaViolenciaGenero(true);
      setDataDeclaracionJuradaViolenciaGenero(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionJuradaViolenciaGenero(false);
      setErrorCreateDeclaracionJuradaViolenciaGenero(err.response.data)
    })
  }

  return {
    updateDeclaracionJuradaViolenciaGeneroById,
    loadingUpdateDeclaracionJuradaViolenciaGeneroById,
    successUpdateDeclaracionJuradaViolenciaGeneroById,
    errorUpdateDeclaracionJuradaViolenciaGeneroById,
    dataUpdateDeclaracionJuradaViolenciaGeneroById
  }

}

export default useUpdateDeclaracionJuradaViolenciaGeneroByID;
